import {
    Component,
    ViewContainerRef,
    ViewChild,
    TemplateRef, OnDestroy, OnInit,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalDialogService } from 'ngx-modal-dialog';
import { FileUploader } from 'ng2-file-upload';
import { Helpers } from '../../services/Helpers';
import { EnvironmentServices } from '../../services/evironment.service';
import {ChatGptCheckingStartDTO, ChatGptTrainingRule, CrawlerSessionDto} from "../../data/Entities";
import {Subscription, timer} from "rxjs";

@Component({
    selector: 'providerapp',
    templateUrl: '/templates/get/Provider/provider',
})

export class ProviderComponent implements OnDestroy, OnInit {
    public errstr = '';
    pid: string = 'PROVIDER';
    public providers: Array<any> = [];

    public engine: any = [];
    public modalRef: BsModalRef;
    public imageengine: any = [];
    public siteImagesURL: string;
    public validDay: Date = new Date();
    public importResult: any = {};
    public selectedProvider: any;
    
    @ViewChild('prodtemplate')
    private prodTemplateRef: TemplateRef<any>;

    @ViewChild('providertemplate')
    private providerTemplateRef: TemplateRef<any>;

    @ViewChild('crawlerstatisticstemplate')
    private crawlerStatisticsTemplateRef: TemplateRef<any>;
    
    public uploader: FileUploader;
    public logoUploader: FileUploader;
    public headerLogoUploader: FileUploader;
    public coverUploader: FileUploader;
    public bFeedUploader: FileUploader;
    public dFeedUploader: FileUploader;
    public previewUploader: FileUploader;
    public preFeedUploader: FileUploader;

    isupload: boolean;
    hasUrl = false;
    autoFeedUrlForcedPropertyUpdate = false;
    provInfo: any;
    zipListStr: string = '';
    zipList: string[] = [];
    crawlerStatistic: any;
    uploadFile: File;
    previewBtnEnabled: Array<string> = ['ALDI', 'HOFER'];

    forceUpdate = false;
    fetchProgress: boolean;

    private isVisible: boolean = false;
    private activeFetchStatus: CrawlerSessionDto[] = [];
    private crawlerSessionList: CrawlerSessionDto[] = [];
    private showCrawlerStatusContent:boolean[] = [];
    
    private readonly fetchStatusSubscription: Subscription;
    
    constructor(
        public siteServices: SiteServices,
        public viewRef: ViewContainerRef,
        private modalService: BsModalService,
        public _environmentServices: EnvironmentServices,
        public modalService2: ModalDialogService
    ) {
        this.siteImagesURL = this._environmentServices.getSiteImagesUrl();
        this.siteServices.provider_Execute(
            'PROVIDER',
            'GETALLPROVIDERS',
            this.selectedProvider,
            (data) => {this.providers = data.TagObject.sort((a, b) => a.ProviderCode.localeCompare(b.ProviderCode));}
        );
        this.siteServices.onError.subscribe((x) => {
            this.fetchProgress = false;
        });
        this.createUploader();
        this.createLogoUploader();
        this.createHeaderLogoUploader();
        this.createCoverUploader();
        this.createBFeedUploader();
        this.createDFeedUploader();
        this.createPreFeedUploader();

        this.fetchStatusSubscription = timer(0, 10000).subscribe(() => {
            if (this.selectedProvider && this.selectedProvider.ProviderCode) {
                this.fetchStatus();
            }
        });
    }

    ngOnInit() {
        document.getElementById("providers").focus();
    }

    ngOnDestroy(): void {
        if (this.fetchStatusSubscription) {
            this.fetchStatusSubscription.unsubscribe();
        }
    }

    createCoverUploader() {
        this.coverUploader = new FileUploader({
            url: '/provider/uploadCover/',
        });
        this.coverUploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.coverUploader.onSuccessItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.isupload = false;
            let r = JSON.parse(response);
            //location.reload();

            if (r.ErrorTxt) {
                this.errstr = r.ErrorTxt;
                this.siteServices.error(this.errstr);
                this.importResult = r.TagObject;
            }
            this.modalRef.hide();
            //this.entity.MediaGUID = r.Tag;
        };
        this.coverUploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            fileItem.alias = this.selectedProvider.ProviderCode;
            this.importResult = {};
            this.engine[this.selectedProvider.ProviderCode] = {
                ProviderCode: this.selectedProvider.ProviderCode,
                forcedPropertyUpdate: this.forceUpdate,
            };
        };
        this.coverUploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            // location.reload();
        };
        this.coverUploader.options['autoUpload'] = true;
    }

    public createLogoUploader() {
        /******************************/
        this.logoUploader = new FileUploader({ url: '/provider/uploadLogo/' });
        this.logoUploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.logoUploader.onSuccessItem = (item, response, status, headers) => {
            this.isupload = false;
            let r = JSON.parse(response);
            //location.reload();

            if (r.ErrorTxt) {
                this.errstr = r.ErrorTxt;
                this.siteServices.error(this.errstr);
                this.importResult = r.TagObject;
            }                
            this.modalRef.hide();
            //this.entity.MediaGUID = r.Tag;
        };
        this.logoUploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            fileItem.alias = this.selectedProvider.ProviderCode;
            this.importResult = {};
            this.engine[this.selectedProvider.ProviderCode] = {
                ProviderCode: this.selectedProvider.ProviderCode,
                forcedPropertyUpdate: this.forceUpdate,
            };
        };
        this.logoUploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            // location.reload();
        };
        this.logoUploader.options['autoUpload'] = true;
    }

    public createHeaderLogoUploader() {
        this.headerLogoUploader = new FileUploader({
            url: '/provider/uploadHeaderLogo/',
        });
        this.headerLogoUploader.onErrorItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.headerLogoUploader.onSuccessItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.isupload = false;
            let r = JSON.parse(response);
            //location.reload();

            if (r.ErrorTxt) {
                this.errstr = r.ErrorTxt;
                this.siteServices.error(this.errstr);
                this.importResult = r.TagObject;
            }
            this.modalRef.hide();
            //this.entity.MediaGUID = r.Tag;
        };
        this.headerLogoUploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            fileItem.alias = this.selectedProvider.ProviderName;
            this.importResult = {};
            this.engine[this.selectedProvider.ProviderCode] = {
                ProviderCode: this.selectedProvider.ProviderCode,
                forcedPropertyUpdate: this.forceUpdate,
            };
        };
        this.headerLogoUploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            // location.reload();
        };
        this.headerLogoUploader.options['autoUpload'] = true;
    }

    public createPreFeedUploader() {
        this.preFeedUploader = new FileUploader({
            url: '/provider/uploadproduct-preview/',
        });

        this.preFeedUploader.onErrorItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.preFeedUploader.onSuccessItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.isupload = false;
            let resJs = JSON.parse(response);

            if (resJs.ErrorTxt) {
                this.errstr = resJs.ErrorTxt;
                this.siteServices.error(this.errstr);
                this.importResult = resJs.TagObject;
                //this.modalRef.hide();
            } else {
                //this.pollFetchResult(this.CURPROVIDER);
                //this.importResult = r.TagObject;
                //this.modalRef.hide();
                this.crawlerStatistic = resJs.delProductCounter;
            }

            //this.entity.MediaGUID = r.Tag;
        };
        this.preFeedUploader.onBeforeUploadItem = (fileItem) => {
            console.log(this.forceUpdate);
            this.errstr = '';
            this.isupload = true;
            fileItem.alias = this.selectedProvider.ProviderCode + '#' + this.forceUpdate;
            this.importResult = {};
            this.engine[this.selectedProvider.ProviderCode] = {
                ProviderCode: this.selectedProvider.ProviderCode,
                forcedPropertyUpdate: this.forceUpdate,
            };
        };

        this.preFeedUploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
        };
        this.preFeedUploader.options['autoUpload'] = false;
    }

    public createUploader() {
        this.uploader = new FileUploader({ url: '/provider/uploadproduct/' });

        this.uploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.uploader.onSuccessItem = (item, response, status, headers) => {
            this.isupload = false;
            let r = JSON.parse(response);

            if (r.ErrorTxt) {
                this.errstr = r.ErrorTxt;
                this.siteServices.error(this.errstr);
                this.importResult = r.TagObject;
            }
            this.modalRef.hide();
            //this.entity.MediaGUID = r.Tag;
        };
        this.uploader.onBeforeUploadItem = (fileItem) => {
            console.log(this.forceUpdate);
            this.errstr = '';
            this.isupload = true;
            fileItem.alias = this.selectedProvider.ProviderCode + '#' + this.forceUpdate;
            this.importResult = {};
            this.engine[this.selectedProvider.ProviderCode] = {
                ProviderCode: this.selectedProvider.ProviderCode,
                forcedPropertyUpdate: this.forceUpdate,
            };
        };

        this.uploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
        };
        this.uploader.options['autoUpload'] = false;
    }

    createBFeedUploader() {
        this.bFeedUploader = new FileUploader({
            url: '/provider/UploadBFeed/',
        });

        this.bFeedUploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.bFeedUploader.onSuccessItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.isupload = false;
            let r = JSON.parse(response);

            if (r.ErrorTxt) {
                this.errstr = r.ErrorTxt;
                this.siteServices.error(this.errstr);
                this.importResult = r.TagObject;
            }
            this.modalRef.hide();
            //this.entity.MediaGUID = r.Tag;
        };
        this.bFeedUploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            fileItem.alias =
                this.selectedProvider.ProviderCode + '#' + Helpers.formatDate(this.validDay);
            this.importResult = {};
            this.engine[this.selectedProvider.ProviderCode] = {
                ProviderCode: this.selectedProvider.ProviderCode,
            };
        };

        this.bFeedUploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.bFeedUploader.options['autoUpload'] = true;
    }

    //Deposit feed uploader
    createDFeedUploader() {
        this.dFeedUploader = new FileUploader({
            url: '/provider/UploadDFeed/',
        });

        this.dFeedUploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.dFeedUploader.onSuccessItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.isupload = false;
            let r = JSON.parse(response);

            if (r.ErrorTxt) {
                this.errstr = r.ErrorTxt;
                this.siteServices.error(this.errstr);
                this.importResult = r.TagObject;
                this.modalRef.hide();
            } else {
                window.scrollTo(0, document.body.scrollHeight);
                this.pollBFeedFetchResult(this.selectedProvider.ProviderCode, r.Tag);
                //this.importResult = r.TagObject;
                this.modalRef.hide();
            }
            //this.entity.MediaGUID = r.Tag;
        };
        this.dFeedUploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
            fileItem.alias =
                this.selectedProvider.ProviderCode + '#' + Helpers.formatDate(this.validDay);
            this.importResult = {};
            this.engine[this.selectedProvider.ProviderCode] = {
                ProviderCode: this.selectedProvider.ProviderCode,
            };
        };

        this.dFeedUploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.dFeedUploader.options['autoUpload'] = true;
    }
    
    private fetchStatus(): void {
        this.siteServices.provider_Execute(
            "PROVIDER",
            'GETFETCHPRODUCTRESULT',
            {},
            (data) => {
                this.activeFetchStatus = data.TagObject;
            }
        );
    }

    private getCrawlerSessionList(providerCode: string): void {
        this.siteServices.provider_Execute(
            "PROVIDER",
            'GETCRAWLERSESSIONLIST',
            providerCode,
            (data) => {
                this.crawlerSessionList = data.TagObject;
            }
        );
    }

    public pollBFeedFetchResult(providerCode: string, token: string) {
        if (
            this.engine[providerCode] &&
            this.engine[providerCode].Percent >= 100
        ) {
            return;
        }

        if (!this.fetchProgress) {
            this.fetchProgress = true;
            this.siteServices.provider_ExecuteCrawler(
                providerCode,
                'GETFETCHBFEEDRESULT',
                { Token: token },
                (data) => {
                    this.fetchProgress = false;
                    if (data.TagObject) {
                        Object.assign(
                            this.engine[providerCode],
                            data.TagObject
                        );
                    }
                    //else this.engine[providerCode] = null;
                }
            );
        }
        setTimeout(() => {
            this.pollBFeedFetchResult(providerCode, token);
        }, 3000);
    }

    public pollFetchImageResult(providerCode: string) {
        this.siteServices.provider_ExecuteCrawler(
            providerCode,
            'GETFETCHIMAGERESULT',
            {},
            (data) => {
                Object.assign(this.imageengine[providerCode], data.TagObject);
            }
        );
        setTimeout(() => {
            this.pollFetchImageResult(providerCode);
        }, 4000);
    }

    public startCrawler(providerCode) {
        if (this.engine[providerCode]) return;

        this.engine[providerCode] = {
            ProviderCode: providerCode,
        };

        this.siteServices.provider_ExecuteCrawler(
            providerCode,
            'CRAWLPRODUCT',
            {},
            () => {
            }
        );
    }

    public startImage(providerCode) {
        if (this.imageengine[providerCode]) return;

        this.imageengine[providerCode] = {
            ProviderCode: providerCode,
            forcedPropertyUpdate: this.forceUpdate,
        };

        this.siteServices.provider_ExecuteCrawler(
            providerCode,
            'PROCESSIMAGES',
            {},
            (data) => {
                this.pollFetchImageResult(providerCode);
            }
        );
    }

    importProd(providerCode: string) {
        this.crawlerStatistic = null;
        this.modalRef = this.modalService.show(this.prodTemplateRef, {
            class: 'modal-md',
        });
    }

    openCrawlerStatistics(providerCode: string) {
        this.getCrawlerSessionList(providerCode);
        this.modalRef = this.modalService.show(this.crawlerStatisticsTemplateRef, {
             class: 'modal-xxl',
        });
    }

    dmy() {
        return Helpers.GetTicks();
    }

    openProviderInfo(providerCode: string, provider: any) {
        this.modalRef = this.modalService.show(this.providerTemplateRef, {
            class: 'modal-md',
        });
        this.siteServices.provider_Execute(
            'PROVIDER',
            'GETPROVIDERINFOS',
            { pCode: this.selectedProvider.ProviderCode },
            (data) => {
                console.log(data);
                this.provInfo = data.TagObject;
                this.zipList = this.provInfo.ZipList;
                console.log(this.zipList);
                this.zipListStr = this.zipList.join(', ');
            }
        );
    }

    modifyProvInfo() {
        if (!confirm('Biztos módosítod?')) {
            alert('Ok, akkor nem módosítjuk. További szép napot!');
            return;
        }
        var inputValue = (<HTMLInputElement>(
            document.getElementById('ProviderNameToShow')
        )).value;

        this.provInfo.ProviderNameToShow = inputValue;

        var hasFeedUrlInfo = (<HTMLInputElement>(
            document.getElementById('HasFeedUrlInfo')
        )).checked;

        this.provInfo.ImportFromFeedUrl = hasFeedUrlInfo;

        var feedUrlInfo = (<HTMLInputElement>(
            document.getElementById('FeedUrlInfo')
        )).value;

        this.provInfo.FeedUrl = feedUrlInfo;

        var autoFeedUrlForcedPropertyUpdateInfo = (<HTMLInputElement>(
            document.getElementById('AutoFeedUrlForcedPropertyUpdateInfo')
        )).checked;

        this.provInfo.AutoFeedUrlForcedPropertyUpdate = autoFeedUrlForcedPropertyUpdateInfo;

        this.siteServices.provider_Execute(
            'PROVIDER',
            'SAVEPROVIDERMODIF',
            this.provInfo,
            (data) => {
                //console.log(data);
                //this.provInfo.ProviderNameToShow = inputValue;
            }
        );
    }

    public changeAvailableStatus(providerCode, event) {
        var cf = confirm('Biztos megváltoztatod?');
        if (cf) {
            this.siteServices.provider_ChangeAvailability(
                providerCode,
                'CHANGEPROVAVAILABILITY',
                { providerCode: providerCode },
                (data) => {
                    alert(data);
                    location.reload();
                }
            );
        }
    }

    public updateDeliveryZipList() {
        var fromJson = {
            zipList: (document.getElementById('zipList') as HTMLInputElement)
                .value,
            pCode: this.selectedProvider.ProviderCode,
        };
        console.log(fromJson);
        this.siteServices.provider_Execute(
            'provider',
            'UPDATEDELIVERYZIPLIST',
            { data: fromJson },
            (data) => {
                alert(data);
                location.reload();
            }
        );
    }

    public changeRokshDeliveryStatus(providerCode, event) {
        var cf = confirm('Biztos megváltoztatod?');
        if (cf) {
            this.siteServices.provider_ChangeRokshDelivery(
                providerCode,
                'CHANGEROKSHDELIVERY',
                { providerCode: providerCode },
                (data) => {
                    alert(data);
                    location.reload();
                }
            );
        }
    }

    public changeRokshForceProductFromFeedStatus(providerCode, event) {
        var cf = confirm('Biztos megváltoztatod?');
        if (cf) {
            this.siteServices.provider_Execute(
                'PROVIDER',
                'CHANGEFORCEPRODUCTFROMFEED',
                {
                    ProviderCode: providerCode,
                    ForceProductFromFeed: event.currentTarget.checked,
                },
                (data) => {
                    location.reload();
                }
            );
        }
    }

    public changeVisibleOnRokshLandingStatus(providerCode, event) {
        var cf = confirm('Biztos megváltoztatod?');
        if (cf) {
            this.siteServices.provider_Execute(
                'PROVIDER',
                'CHANGEVISIBLEONROKSHLANDING',
                {
                    ProviderCode: providerCode,
                    VisibleOnRokshLanding: event.currentTarget.checked,
                },
                data => {
                    location.reload();
                }
            );
        }
    }

    public changeIsMolAvailableStatus(providerCode, event) {
        var cf = confirm('Biztos megváltoztatod?');
        if (cf) {
            this.siteServices.provider_Execute(
                'PROVIDER',
                'CHANGEMOLAVAILABLEONROKSH',
                {
                    ProviderCode: providerCode,
                    IsMolAvailable: event.currentTarget.checked,
                },
                data => {
                    location.reload();
                }
            );
        }
    }

    public savetimeslotdaysevent(providerCode, event) {
        if (event.currentTarget.value != null && event.currentTarget.value > 0 && confirm('Biztos megváltoztatod?')) {
            debugger;
            this.siteServices.provider_Execute(
                    'PROVIDER',
                    'CHANGETIMESLOTDAYSTOSHOW',
                    {
                        ProviderCode: providerCode,
                        TimeslotDaysToShow: event.currentTarget.value,
                    },
                    data => {});
        }

        location.reload();
    }

    public showFeedUrlBox(event) {
        if (event.target.checked == true) {
            this.hasUrl = true;
        } else {
            this.hasUrl = false;
        }
    }

    public showAutoFeedUrlForcedPropertyUpdate(event) {
        if (event.target.checked == true) {
            this.autoFeedUrlForcedPropertyUpdate = true;
        } else {
            this.autoFeedUrlForcedPropertyUpdate = false;
        }
    }



    public addNewProvider() {
        var feedUrl = '';
        if (this.hasUrl)
            feedUrl = (document.getElementById('FeedUrl') as HTMLInputElement)
                .value;
        var fromJson = {
            ProviderName: (
                document.getElementById('ProviderName') as HTMLInputElement
            ).value,
            ProviderCode: (
                document.getElementById('ProviderCode') as HTMLInputElement
            ).value,
            HasUrl: this.hasUrl,
            AutoFeedUrlForcedPropertyUpdate: this.autoFeedUrlForcedPropertyUpdate,
            FeedUrl: feedUrl,
            CompanyName: (
                document.getElementById('CompanyName') as HTMLInputElement
            ).value,
            WebshopLink: (
                document.getElementById('WebshopLink') as HTMLInputElement
            ).value,
            CompanyRegistrationNumber: (
                document.getElementById(
                    'CompanyRegistrationNumber'
                ) as HTMLInputElement
            ).value,
            TaxNumber: (
                document.getElementById('TaxNumber') as HTMLInputElement
            ).value,
            ContactName: (
                document.getElementById('ContactName') as HTMLInputElement
            ).value,
            ContactMail: (
                document.getElementById('ContactMail') as HTMLInputElement
            ).value,
            ContactPhone: (
                document.getElementById('ContactPhone') as HTMLInputElement
            ).value,
            ContactAddress: (
                document.getElementById('ContactAddress') as HTMLInputElement
            ).value,
        };

        this.siteServices.provider_Execute(
            'PROVIDER',
            'ADDPROVIDER',
            { formData: fromJson },
            (data) => {
                alert(data);
                location.reload();
            }
        );
    }

    handleFileInput(files: FileList) {
        this.crawlerStatistic = null;

        if (files.length > 0) {
            this.preFeedUploader.addToQueue(Array.from(files));
            this.uploader.addToQueue(Array.from(files));
        } else {
            this.preFeedUploader.clearQueue();
            this.uploader.clearQueue();
        }
    }

    cancelCrawler(crawlerSessionId: number) {
        console.log('Stop: ' + crawlerSessionId);
        const currentSession = this.activeFetchStatus.find(x => x.CrawlerSessionId == crawlerSessionId);
        console.log('Stop2: ' + currentSession);
        
        if (currentSession.Status == 'Complete' || currentSession.Status == 'Error' || currentSession.Status == 'Cancelled') {
            return;
        }

        this.siteServices.provider_Execute(
            "PROVIDER",
            'CANCELFETCHPRODUCT',
            crawlerSessionId,
            () => {}
        );
    }

    toggle(index) {
        this.showCrawlerStatusContent[index] = !this.showCrawlerStatusContent[index];
    }
}
